const checkStatusToBlockChangesInOrder = orderStatus => {
  return orderStatus !== 'IN_PROGRESS';
};

export default checkStatusToBlockChangesInOrder;
